import React from 'react';
import Link from 'next/link';
import { Navigation } from './Navigation';
import { SignOut }  from 'phosphor-react';
import * as S from './Styles';
import styled from 'styled-components';
import { useAuth0 } from "@auth0/auth0-react";

const SignoutButton = styled.a`
    display: flex;
    align-items: center;

    color: #999;
    font-size: 1.4rem;

    svg {
        margin-right: 1rem;
    }

    &:hover {
        color: #fff;
    }
`;

const Header = () => {
    const { logout } = useAuth0();

    return (
        <S.Header>
            <S.HeaderContainer>
                <S.NavigationContainer>
                    <Link href="/">
                        <a>
                            <S.Logo src="/gymshark.png" />
                        </a>
                    </Link>

                    <Navigation />
                </S.NavigationContainer>

                <SignoutButton onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
                    <SignOut size={25} />

                    Logout
                </SignoutButton>
            </S.HeaderContainer>
        </S.Header>
    );
};

export { Header }
